import React from 'react'

const UploadIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Tray */}
    <path
      d="M4 18.5C4 18.2239 4.22386 18 4.5 18H19.5C19.7761 18 20 18.2239 20 18.5C20 18.7761 19.7761 19 19.5 19H4.5C4.22386 19 4 18.7761 4 18.5Z"
      fill="#FFFFFF"
      stroke="#EF8658"
    />

    {/* Arrow up */}
    <path
      d="M12 5L7.5 9.5C7.30964 9.69036 7.30964 10.3096 7.5 10.5C7.69036 10.6904 8.30964 10.6904 8.5 10.5L11 8V15.5C11 15.7761 11.2239 16 11.5 16C11.7761 16 12 15.7761 12 15.5V8L14.5 10.5C14.6904 10.6904 15.3096 10.6904 15.5 10.5C15.6904 10.3096 15.6904 9.69036 15.5 9.5L12 5Z"
      fill="#FFFFFF"
      stroke="#EF8658"
    />
  </svg>
)

export default UploadIcon